module.exports = "<div class=\"container\">\n  <div class=\"page-500\">\n    <div class=\"page-500-error heyground-font\">ERROR</div>\n    <img class=\"page-500-image\" src=\"assets/images/500.png\">\n    <div class=\"page-500-text\">\"HTTP 502 - 서버 점검 중에 있습니다.\"</div>\n\n    <div class=\"page-500-bottom-text\">사이트 이용에 불편을 드려 죄송합니다. -헤이그라운드-</div>\n    <img class=\"page-500-bottom-image\" src=\"assets/images/error-bottom.png\">\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-502/page-502.component.html
// module id = 1134
// module chunks = 0